const FACEBOOK_STYLE_AVATAR_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <rect width="64" height="64" rx="32" fill="#e4e6eb"/>
  <circle cx="32" cy="24" r="12" fill="#bcc0c4"/>
  <path d="M12 58c0-11.05 8.95-20 20-20s20 8.95 20 20v6H12v-6z" fill="#bcc0c4"/>
</svg>
`.trim();

const toDataUri = (svg: string) => `data:image/svg+xml,${encodeURIComponent(svg)}`;

export const normalizeTitle = (value?: string | null) => {
  if (!value) return "";
  return String(value).trim();
};

export const inferGenderFromTitle = (_title?: string | null) => {
  return null;
};

export const getDefaultAvatarForTitle = (_title?: string | null) => {
  return toDataUri(FACEBOOK_STYLE_AVATAR_SVG);
};
